<template>
  <v-dialog v-model="dialog" :persistent="true" max-width="900"> <v-card>
      <v-card-title style="word-break: break-word; width: 97%; text-align: center;">
        {{ titulo[tipoTermo] }}
      </v-card-title>
      <v-card-text>
        <div class="mb-4">{{ $tc('message.selecione_termo_visualizar') }}</div>
        <v-data-table
          :headers="headers"
          :items="termos"
          :items-per-page="-1"
          :no-data-text="$t('message.nenhum_registro')"
        >
          <template v-slot:item="{ item }">
            <tr v-if="tipoTermo === 'termoUso'">
              <td><v-icon @click="visualizar(item)">visibility</v-icon></td>
              <td>{{ item.nome_sobrenome }}</td>
              <td>{{ item.dta_aceite }}</td>
            </tr>
            <tr v-if="tipoTermo === 'termoNomeacao'">
              <td>
                <v-icon @click="visualizar(item)">visibility</v-icon>
              </td>
              <td>{{ item.nome_sobrenome_cadastrado }}</td>
              <td>{{ item.nome_sobrenome_aceite }}</td>
              <td>
                 {{ item.nome_grupo_fornecedor || '-' }}
              </td>
              <td>{{ item.dta_aceite }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.native="cancelar">{{ $t('label.cancelar') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ModalListaTermosAceite',
  props: {
  },
  data() {
    return {
      usuarioResource: this.$api.usuario(this.$resource),
      termoAceiteResource: this.$api.termoAceite(this.$resource),
      dialog: false,
      tipoTermo: '',
      termos: [],
      aceites: [],
      titulo: {
        termoNomeacao: this.$tc('label.termo_nomeacao'),
        termoUso: this.$tc('label.termo_uso'),
      },
      rotasTermos: {
        termoNomeacao: 'verAceiteTermoNomeacao',
        termoUso: 'verAceiteTermoUso',
      },
    };
  },
  computed: {
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    selecionados() {
      return this.termos.filter((i) => i.selected);
    },
    headers() {
      if (this.tipoTermo === 'termoNomeacao') {
        return [
          {
            text: '', value: 'visualizar', align: 'center', sortable: false,
          },
          {
            text: `${this.$tc('label.aprovador_autorizado_nomeado', 1)}`, value: 'nome_sobrenome_cadastrado', align: 'left',
          },
          {
            text: `${this.$tc('label.representante_legal_nomeador', 1)}`, value: 'nome_sobrenome_aceite', align: 'left',
          },
          {
            text: `${this.$tc('label.grupo_fornecedor', 1)}`, value: 'nome_grupo_fornecedor', align: 'left',
          },
          {
            text: `${this.$tc('label.data_aceite', 1)}`, value: 'dta_aceite', align: 'left',
          },
          {
            text: '', value: 'selecionar', align: 'center', sortable: false,
          },
        ];
      }
      return [
        {
          text: '', value: 'visualizar', align: 'center', sortable: false,
        },
        {
          text: `${this.$tc('label.nome_sobrenome', 1)}`, value: 'nome_sobrenome', align: 'left',
        },
        {
          text: `${this.$tc('label.data_aceite', 1)}`, value: 'dta_aceite', align: 'left',
        },
      ];
    },

  },
  methods: {
    cancelar() {
      this.tipoTermo = '';
      this.termos = [];
      this.dialog = false;
    },
    visualizar(item) {
      const route = this.$router.resolve({
        name: this.rotasTermos[this.tipoTermo],
        params: { idAceite: item.id },
      });
      window.open(route.href, '_blank');
    },
    open(termos, tipoTermo) {
      if (termos) this.termos = termos;
      if (tipoTermo) this.tipoTermo = tipoTermo;
      this.dialog = true;
    },
    buscarAceites(idsAceites) {
      this.termoAceiteResource.buscarAceitesTermoNomeacao({ idsAceites }).then((response) => {
        this.aceites = response.data;
      }, (err) => {
        this.$error(this, err);
      });
    },
  },
};
</script>

<style scoped>
</style>
